import {ReactElement} from 'react';
import {Link, Image} from '@shopify/hydrogen';
import {FeatureLinkNavColumnType} from '../../types';

interface NavigationMenuFeatureLinkColumnProps {
  featureLink: FeatureLinkNavColumnType;
}

export default function NavigationMenuFeatureLinkColumn({
  featureLink,
}: NavigationMenuFeatureLinkColumnProps): ReactElement {
  const {
    link,
    title,
    link_target,
    content_text,
    feature_image,
    background_color,
    font_color,
  } = featureLink;
  return (
    <Link
      to={link}
      target={link_target}
      className="submenu__top-col submenu__top-image browse-box browse-box__red"
      style={{
        backgroundColor: background_color,
        color: font_color,
      }}
    >
      <h4 className="browse-box__subtitle">{title}</h4>
      <h3 className="browse-box__title">
        <span dangerouslySetInnerHTML={{__html: content_text}} />
      </h3>
      <span className="browse-box__button">
        {featureLink?.link_text} <i className="icon-right-arrow1" />
      </span>
      <picture>
        {feature_image && (
          <>
            <source srcSet={feature_image} />
            <Image src={feature_image} alt={title} width={170} height={220} />
          </>
        )}
      </picture>
    </Link>
  );
}
